import {
  UPDATE_USER_ACCOUNT,
  JUDGE_USER_ACCOUNT,
  UPDATE_USER_PASSWORD,
  JUDGE_USER_PASSWORD,
  UPDATE_USER_REPASSWORD,
  JUDGE_USER_REPASSWORD,
  FB_LOGIN_HREF,
  TWI_LOGIN_HREF,
  LINE_LOGIN_HREF,
  UPDATE_REMEMBER,
  LOGIN_CHECK,
  GOTO_REGISTER,
  REGISTER_CHECK,
  GOTO_LOGIN,
  GO_LOGIN,
  GO_REGISTER,
  paramForward,
  GOOGLE_PLAY_LOGIN_HREF,
  VK_LOGIN_HREF,
  APPLE_LOGIN_HREF,
  GOTO_UID_TOKEN_LOGIN,
  GO_RO_LOGIN_BIND_ACCOUNT
} from '../store/web/login';

import globalConfig from '../utiles/globalConfig';
import bridge from '@utiles/bridge';

// 显示uid令牌登录的游戏
// 2022.12.07 蚂蚁添加uid令牌入口
// 2024.04.01 K1添加uid令牌入口
// 2024.07.12 侏罗纪军团添加uid令牌入口
// 2024.10.29 日本霸业2.0添加uid令牌入口
// 2025.04.23 霸业2.0全球版添加uid令牌入口
// 2025.06.06 时光大爆炸_日语版添加uid令牌入口
// 2025.06.30 英雄没有闪_欧洲版添加uid令牌入口
const showUidTokenGameId = [
  175, 209, 221, 225, 227, 284, 191, 288, 274, 261, 221, 195, 201, 263, 269,
  321, 295, 306, 322, 324, 337, 333, 314, 294, 285, 370, 355, 354, 331, 390,
  382, 424, 410, 429, 454, 440
];

export default {
  data() {
    return {
      userAccount: '',
      userPassword: '',
      reuserPassword: '',
      isAgreeTerm: true,
      canLogin: true,
      canRegister: true,
      musVn:
        globalConfig.getHrefParam('gameId') == 201 ||
        globalConfig.getHrefParam('game_id') == 201 ||
        this.$store.state.gameId == 201,
      runInIframe:
        (globalConfig.getHrefParam('gameId') == 201 ||
          globalConfig.getHrefParam('game_id') == 201 ||
          this.$store.state.gameId == 201) &&
        globalConfig.getHrefParam('fromIframe') === '1',
      loading: false
    };
  },
  computed: {
    showFakePasswordRepeat() {
      return this.$store.state.passwordRepeatErrPos !== -1;
    },
    passwordRepeatErrPos() {
      return this.$store.state.passwordRepeatErrPos;
    },
    letter() {
      return this.$store.state.letter;
    },
    userAccountTips() {
      return this.$store.state.userAccountTips;
    },
    userPasswordTips() {
      return this.$store.state.passwordTips;
    },
    repasswordTips() {
      return this.$store.state.repasswordTips;
    },
    loginRequestTips() {
      return this.$store.state.loginRequest;
    },
    registerRequestTips() {
      return this.$store.state.registerRequest;
    },
    thirdList() {
      // 2026.2.25 需求人：李紫健2号，过滤三方登录列表，webview环境隐藏google登录
      if (globalConfig.isExternalAppWebview() || bridge.runInsdk()) {
        return this.$store.state.thirdList.filter(item =>
          !['googleplay'].includes(item)
        );
      }
      return this.$store.state.thirdList;
    },
    loginHref() {
      const tips = `javascript:alert('${this.letter.unLink}')`;
      let realForwardUrl =
        globalConfig.getHrefParamUndecode('tpForward') || paramForward;
      // 2025.4.11 ROG提供登录功能支持研发页面接入
      const callerRedirectUrl =
        globalConfig.getHrefParamUndecode('caller_redirect_url') || '';
      // 2017.1.17
      // web_source：用来标记从平台登录页登录注册的数据，并在后端进行过滤（避免非h5游戏产生web端新用户数据）
      return {
        facebook:
          FB_LOGIN_HREF +
            this.$store.state.lang +
            `&game_id=${
              this.gameId
            }&web_source=platform&timeZone=${encodeURIComponent(
              globalConfig.getTimeZone()
            )}&caller_redirect_url=${encodeURIComponent(
              callerRedirectUrl
            )}&forward=${encodeURIComponent(
              globalConfig.hrefAddParam(realForwardUrl, 'gameId', this.gameId)
            )}` || tips,
        twitter:
          TWI_LOGIN_HREF +
            this.$store.state.lang +
            `&game_id=${
              this.gameId
            }&web_source=platform&timeZone=${encodeURIComponent(
              globalConfig.getTimeZone()
            )}&caller_redirect_url=${encodeURIComponent(
              callerRedirectUrl
            )}&forward=${encodeURIComponent(
              globalConfig.hrefAddParam(realForwardUrl, 'gameId', this.gameId)
            )}` || tips,
        line:
          LINE_LOGIN_HREF +
            this.$store.state.lang +
            `&game_id=${
              this.gameId
            }&web_source=platform&timeZone=${encodeURIComponent(
              globalConfig.getTimeZone()
            )}&caller_redirect_url=${encodeURIComponent(
              callerRedirectUrl
            )}&forward=${encodeURIComponent(
              globalConfig.hrefAddParam(realForwardUrl, 'gameId', this.gameId)
            )}` || tips,
        naver: tips,
        googleplay:
          GOOGLE_PLAY_LOGIN_HREF +
            this.$store.state.lang +
            `&game_id=${
              this.gameId
            }&web_source=platform&timeZone=${encodeURIComponent(
              globalConfig.getTimeZone()
            )}&caller_redirect_url=${encodeURIComponent(
              callerRedirectUrl
            )}&forward=${encodeURIComponent(
              globalConfig.hrefAddParam(realForwardUrl, 'gameId', this.gameId)
            )}` || tips,
        vk:
          VK_LOGIN_HREF +
            this.$store.state.lang +
            `&game_id=${
              this.gameId
            }&web_source=platform&timeZone=${encodeURIComponent(
              globalConfig.getTimeZone()
            )}&caller_redirect_url=${encodeURIComponent(
              callerRedirectUrl
            )}&forward=${encodeURIComponent(
              globalConfig.hrefAddParam(realForwardUrl, 'gameId', this.gameId)
            )}` || tips,
        apple:
          APPLE_LOGIN_HREF +
            this.$store.state.lang +
            `&game_id=${
              this.gameId
            }&web_source=platform&timeZone=${encodeURIComponent(
              globalConfig.getTimeZone()
            )}&caller_redirect_url=${encodeURIComponent(
              callerRedirectUrl
            )}&forward=${encodeURIComponent(
              globalConfig.hrefAddParam(realForwardUrl, 'gameId', this.gameId)
            )}` || tips
      };
    },
    isRemember() {
      return !!this.$store.state.isRemember;
    },
    termTips() {
      return this.$store.state.registerTermTips;
    },
    gameId() {
      return this.$store.state.gameId;
    },
    showUidTokenWay() {
      return showUidTokenGameId.includes(+this.gameId);
    }
  },
  methods: {
    judgeUserAccount() {
      this.$store.dispatch(UPDATE_USER_ACCOUNT, this.userAccount);
      this.$store.dispatch(JUDGE_USER_ACCOUNT, this.userAccount);
    },
    judgeUserPassword() {
      this.$store.dispatch(UPDATE_USER_PASSWORD, this.userPassword);
      this.$store.dispatch(JUDGE_USER_PASSWORD, this.userPassword);
    },
    judgeUserRepassword() {
      this.$store.dispatch(UPDATE_USER_REPASSWORD, this.reuserPassword);
      this.$store.dispatch(JUDGE_USER_REPASSWORD, this.reuserPassword);
    },
    toggleRemember() {
      this.$store.dispatch(UPDATE_REMEMBER);
    },
    toggleAgreeTerm() {
      this.isAgreeTerm = !this.isAgreeTerm;
    },
    // 2025.8.13 RO登录页绑定游戏角色
    roBindAccount() {
      if (this.canLogin) {
        this.canLogin = false;
        this.judgeUserAccount();
        this.judgeUserPassword();
        if (this.userAccountTips || this.userPasswordTips) {
          this.canLogin = true;
          this.$clearDisable('login-in-btn');
          return;
        }
        this.loading = true;
        this.$store.dispatch(GO_RO_LOGIN_BIND_ACCOUNT).then(res => {
          if (res.result) {
            if (this.runInIframe) {
              window.parent.postMessage(
                {
                  action: 'refreshPage',
                  url: res.forward
                },
                '*'
              );
            } else {
              window.location.href = res.forward;
            }
            this.loading = false;
          } else {
            this.loading = false;
            this.canLogin = true;
            this.$clearDisable('login-in-btn');
          }
        });
      }
    },
    login() {
      if (this.canLogin) {
        this.canLogin = false;
        this.judgeUserAccount();
        this.judgeUserPassword();
        this.loading = true;
        this.$store.dispatch(LOGIN_CHECK).then(res => {
          if (res) {
            // RoLogin 等人机验证场景可拦截
            if (
              typeof this.beforeGoLogin === 'function' &&
              this.beforeGoLogin() === false
            ) {
              this.loading = false;
              this.canLogin = true;
              this.$clearDisable('login-in-btn');
              return;
            }
            // 2025.4.11 ROG提供登录功能支持研发页面接入
            const callerRedirectUrl =
              globalConfig.getHrefParamUndecode('caller_redirect_url') || '';
            this.$store
              .dispatch(GO_LOGIN, {
                forward: encodeURIComponent(
                  globalConfig.hrefAddParam(paramForward, 'gameId', this.gameId)
                ),
                caller_redirect_url: encodeURIComponent(callerRedirectUrl),
                // token: token
                google_recaptcha_token: window.googleVerificationToken || '' // 空字符串而非 undefined
              })
              .then(res => {
                if (res.result) {
                  if (typeof this.afterGoLoginSuccess === 'function') {
                    this.afterGoLoginSuccess(res);
                  }
                  if (this.runInIframe) {
                    window.parent.postMessage(
                      {
                        action: 'refreshPage',
                        url: res.forward
                      },
                      '*'
                    );
                  } else {
                    window.location.href = res.forward;
                  }
                  this.loading = false;
                } else {
                  if (
                    typeof this.onGoLoginFail === 'function' &&
                    this.onGoLoginFail(res)
                  ) {
                    this.loading = false;
                    this.canLogin = true;
                    this.$clearDisable('login-in-btn');
                    return;
                  }
                  this.loading = false;
                  this.canLogin = true;
                  this.$clearDisable('login-in-btn');
                }
              });
            // grecaptcha.execute();
          } else {
            this.loading = false;
            this.canLogin = true;
            this.$clearDisable('login-in-btn');
          }
        });
      }
    },
    register() {
      if (this.canRegister) {
        this.canRegister = false;
        this.judgeUserAccount();
        this.judgeUserPassword();
        this.judgeUserRepassword();
        this.loading = true;
        this.$store.dispatch(REGISTER_CHECK, this.isAgreeTerm).then(res => {
          if (res) {
            if (
              typeof this.beforeGoRegister === 'function' &&
              this.beforeGoRegister() === false
            ) {
              this.loading = false;
              this.canRegister = true;
              this.$clearDisable('register-btn');
              return;
            }
            const callerRedirectUrl =
              globalConfig.getHrefParamUndecode('caller_redirect_url') || '';
            this.$store
              .dispatch(GO_REGISTER, {
                forward: encodeURIComponent(
                  globalConfig.hrefAddParam(paramForward, 'gameId', this.gameId)
                ),
                caller_redirect_url: encodeURIComponent(callerRedirectUrl)
                // token: token
              })
              .then(res => {
                if (res.result) {
                  if (typeof this.afterGoRegisterSuccess === 'function') {
                    this.afterGoRegisterSuccess(res);
                  }
                  if (this.runInIframe) {
                    window.parent.postMessage(
                      {
                        action: 'refreshPage',
                        url: res.forward
                      },
                      '*'
                    );
                  } else {
                    window.location.href = res.forward;
                  }
                  this.loading = false;
                } else {
                  if (typeof this.onGoRegisterFail === 'function') {
                    this.onGoRegisterFail(res);
                  }
                  this.loading = false;
                  this.canRegister = true;
                  this.$clearDisable('register-btn');
                }
              });
            // grecaptcha.execute();
          } else {
            this.loading = false;
            this.canRegister = true;
            this.$clearDisable('register-btn');
          }
        });
      }
    },
    goLogin() {
      this.$store.dispatch(GOTO_LOGIN);
    },
    goRegister() {
      this.$store.dispatch(GOTO_REGISTER);
    },
    goUidTokenLogin() {
      this.$store.commit(GOTO_UID_TOKEN_LOGIN);
    }
  }
};
